// extracted by mini-css-extract-plugin
export default {"row":"a-entity-search-holder-module__row","label-col":"a-entity-search-holder-module__label-col","input-col":"a-entity-search-holder-module__input-col"};